// extracted by mini-css-extract-plugin
export default {"console":"console_console__+d6gz"};